// Continuous editorial marquee (CSS-driven, seamless loop)
export const Marquee = ({
  items = [],
  className = "",
  outline = false,
  cream = false,
  separator = "\u00B7",
}) => {
  const set = [...items, ...items];
  return (
    <div className={`relative flex overflow-hidden ${className}`}>
      <div className="flex w-max shrink-0 animate-marquee items-center">
        {set.map((it, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-extrabold uppercase tracking-tight ${
                outline ? (cream ? "text-outline-cream" : "text-outline") : ""
              }`}
            >
              {it}
            </span>
            <span
              aria-hidden
              className={`mx-8 md:mx-12 text-2xl md:text-4xl ${
                cream ? "text-cream/60" : "text-cab/50"
              }`}
            >
              {separator}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
